<div mat-dialog-title class="title">
    Thông tin tài khoản
</div>
<mat-dialog-content>
    <div class="pt-5 min-w-[35rem]">
        <form [formGroup]="form" class="form-control">
            <div class="flex justify-center mb-5">
                <div>
                    <div class="flex justify-center">
                        <img *ngIf="!imgAvatar" src="assets/images/logo.jpg" alt="" class="imageConfig rounded-full  w-[12rem] h-[12rem]">
                        <img *ngIf="imgAvatar" [src]="imgAvatar| image" alt="" class="imageConfig rounded-full  w-[12rem] h-[12rem]">
                    </div>
                    <div class="flex items-end justify-center mt-3">
                        <button class="text-base whitespace-nowrap" mat-button (click)="f_input.click()">
                            <mat-icon class="me-3">camera_alt</mat-icon>
                            Sửa ảnh đại diện
                        </button>
                    </div>
                </div>
                <input type="file" accept="image/gif, image/jpeg, image/jpg, image/png" multiple hidden #f_input (change)="handleFileInputChange(f_input.files)" />

            </div>
            <div class="flex ">
                <label for="" class="whitespace-nowrap min-w-[40%]">Tên tài khoản</label>
                <mat-form-field class="w-full formcontrol-sm text-base" appearance="outline">
                    <input matInput formControlName="username">
                </mat-form-field>
            </div>
            <div class="flex ">
                <label for="" class="whitespace-nowrap min-w-[40%]">Họ và tên</label>
                <mat-form-field class="w-full formcontrol-sm text-base" appearance="outline">
                    <input matInput formControlName="fullName">
                </mat-form-field>
            </div>
            <div class="flex">
                <label for="" class="whitespace-nowrap min-w-[40%]">Địa chỉ</label>
                <mat-form-field class="w-full text-base" appearance="outline">
                    <input matInput type="email" formControlName="address">
                </mat-form-field>
            </div>
            <div class="flex">
                <label for="" class="whitespace-nowrap min-w-[40%]">Số điện thoại</label>
                <mat-form-field class="w-full text-base" appearance="outline">
                    <input matInput type="email" formControlName="phoneNumber">
                </mat-form-field>
            </div>
            <div class="flex">
                <label for="" class="whitespace-nowrap min-w-[40%]">Chức năng</label>
                <mat-form-field class="w-full text-base" appearance="outline">
                    <input matInput type="email" formControlName="role">
                </mat-form-field>
            </div>
            <div class="flex">
                <label for="" class="whitespace-nowrap min-w-[40%]">Linh giới thiệu</label>
                <mat-form-field class="w-full text-base" appearance="outline" (click)="copyAffiliate()">
                    <input matInput type="text" formControlName="token">
                    <mat-icon matSuffix matTooltip="Coppy link" [matTooltipPosition]="'above'">content_copy</mat-icon>
                </mat-form-field>
            </div>
        </form>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="actions w-full">
    <button class="text-base whitespace-nowrap" mat-button mat-dialog-close>Đóng</button>
</mat-dialog-actions>